"use client"

import FreeShippingIcon from "./free-shipping"
import GuaranteeIcon from "./guarantee"
import SupportIcon from "./support"

const Features = () => {
  const data = [
    {
      icon: <FreeShippingIcon />,
      title: "FREE Fast Shipping",
      description: "2~5 Days Fast Shipping!",
    },
    {
      icon: <GuaranteeIcon />,
      title: "Free Return&Refund",
      description: "30-Day Free Return & Refund!",
    },
    {
      icon: <SupportIcon />,
      title: "Lifetime Warranty",
      description: "Lifetime warranty guaranteed!",
    },
  ]

  return (
    <div className="lg_h-[180px] lg_bg-[#F6F6F6]">
      <div className="mx-auto flex h-full w-[1440px] max-w-full flex-col items-center justify-between gap-[5px] lg_flex-row lg_gap-0">
        {data.map((item, index) => {
          return (
            <div
              className="flex w-full gap-[15px] bg-[#F7F7F5] p-[20px] lg_w-auto lg_bg-[#F6F6F6] lg_p-0"
              key={index}
            >
              <div className="h-[70px] lg_h-[100px]">{item.icon}</div>
              <div className="flex flex-col justify-center gap-[5px]">
                <span className="font-poppins text-[18px] font-[600] leading-[1.4] text-primary lg_text-[20px]">
                  {item.title}
                </span>
                <span className="font-sans text-[16px] leading-[1.4] text-primary">
                  {item.description}
                </span>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Features
